












import {ChartDataTemplate, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"
import {formatNumberWithGrouping, formatNumberWithoutGrouping} from "@/data/sources/numbers";
import {getLocationCaption} from "@/data/sources/appraisal";
import appConfig from "@/config";

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "GiaNia",
    title: "GIA and NIA",
    cType: "overlappedcolumn2d",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
    fusionChartParams: {
      numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
    },
  }
}

function getChartDataConfig() {
  return reactive({
        ...ChartDataTemplate(),
        caption: "Building GIA and NIA Totals",
        yAxisName: "Sq.m",
        showLabels: "1",
        labelDisplay: "rotate",
        slantLabel: "1",
        showValues: "1",
        paletteColors: "#CE782A,#116898",
        // exportEnabled: "1",
        // exportFormats: "PNG=Export as High Quality Image|PDF=Export as Printable Document|XLS=Export Chart Data|CSV=Export Chart Data as csv",
        bgColor: "#FFFFFF",
      },
  )
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  if (config) {
    chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
  }
}

export default defineComponent({
  props: {
    config: {type: Object, required: true},
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    context.emit("config-update", config())

    const chartDSTemplate = reactive({categories: [], dataset: []})

    async function dataFetcher(params: any) {
      // "RegionID":15441150, "RegionName":"LLR - Leicestershire Partnership NHS Trust2", "RegionCode":"",
      // "SiteID":15025270,"SiteName":"Gwendolen House","SiteCode":"004",
      // "BuildingID":15025280,"BuildingName":"Gwendolen House","BuildingCode":"01",
      // "FloorID":15025290,"FloorName":"Ground Floor","FloorCode":"00",
      // "FloorNIA":2296.2500,
      // "FloorGIA":"2379.43",
      // "attachid":44708
      const buildingIds: number[] = []
      const buildingNameMap: Map<number, string> = new Map<number, string>()
      const buildingGiaNiaMap: Map<number, {gia: number, nia: number}> = new Map<number, {gia: number; nia: number}>()
      const data = await executeQuery("idr", "giaNia",
          {locationId: parseInt(params.locationId.value) || 10})
      data.forEach(item => {
        const buildingId = item.BuildingID
        if (!buildingIds.includes(buildingId)) {
          buildingIds.push(buildingId)
          buildingNameMap.set(buildingId, item.BuildingName)
        }
        const itemGiaNia: {gia: number, nia: number} = buildingGiaNiaMap.get(buildingId) || {gia: 0, nia: 0};
        const floorGia = Number(item.FloorGIA)
        const floorNia = Number(item.FloorNIA)
        if (isNaN(floorGia) || isNaN(floorNia))
          console.warn("Invalid GIA & NIA:", item, item.FloorGIA, item.FloorNIA)
        buildingGiaNiaMap.set(buildingId, {
          gia: itemGiaNia.gia + (isNaN(floorGia) ? 0 : floorGia),
          nia: itemGiaNia.nia + (isNaN(floorNia) ? 0 : floorNia),
        })
      })
      const values = Array.from(buildingGiaNiaMap.values())
      const totalGia = values.map(item => item.gia).reduce((prev, curr) => prev + curr, 0);
      const totalNia = values.map(item => item.nia).reduce((prev, curr) => prev + curr, 0);
      return {
        categories: [
          {
            category: buildingIds.map(buildingId => {
              return {
                label: buildingNameMap.get(buildingId)
              }
            })
          }
        ],
        dataset: [
          {
            seriesName: "GIA: " + formatNumberWithGrouping(totalGia),
            data: buildingIds.map(buildingId => {
              const gia = buildingGiaNiaMap.get(buildingId).gia;
              return {
                value: formatNumberWithoutGrouping(gia),
                toolText: buildingNameMap.get(buildingId) + " GIA: " + formatNumberWithGrouping(gia) + " sq.m"
              }
            })
          },
          {
            seriesName: "NIA: " + formatNumberWithGrouping(totalNia),
            data: buildingIds.map(buildingId => {
              const nia = buildingGiaNiaMap.get(buildingId).nia;
              return {
                value: formatNumberWithoutGrouping(nia),
                toolText: buildingNameMap.get(buildingId) + " NIA: " + formatNumberWithGrouping(nia) + " sq.m"
              }
            })
          },
        ],
      }
    }

    function dataplotClickCallback(label: string, val: any, data: any) {
      if (!val) {
        return
      }
      const iprUrl = appConfig.IPR_BASE_URL
      const locationId = props.config.params.locationId.value
      window.open(iprUrl + `/reports/AllFloorsGIAandNUA.asp?id=${locationId}`)
      console.log("chartClickCallback", label, val)
    }

    return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback, chartDSTemplate}
  },
})
